import http from '../Http';
import { useContext } from 'react';
import utils from '../utils';
import { Modal, Button, Input, Form } from 'antd';
import { useTranslation } from 'react-i18next';

function PasswordChanger (props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);
    const {show, onClose} = props;
    const [form] = Form.useForm();

    const handleCancle = () => {
        onClose(null);
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => {return null});
        
        if (ps === null) {
            return;
        }

        ps.OldPassword = ps.OldPassword || "";
        ps.Password = ps.NewPassword || "";

        const resp = await http.post("user/password/update", ps).then(async (r)=>{
            return await r.json();
        }).catch((e) => {
            console.log("[PasswordChanger]", e);
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t('modify error')});
                return
            }

            setTip({open: true, severity: 'success', msg: t('modify success')});

            onClose();
        } catch (e) {
            console.log("[PasswordChanger]", e);
            setTip({open:true, severity:"error", msg: t('modify error')});
        }
    }

    return (<Modal 
        title={t('Change Password')}
        visible={show}
        cancelText={t('Cancel')}
        okText={t('Submit')}
        mask={true}
        maskClosable={false}
        width={600}
        onCancel={handleCancle}
        onOk={handleSubmit}
        footer={[
            <Button 
                key="Clear" 
                onClick={() => {
                    form.resetFields();
                }}
            >{t('Clear')}</Button>,
            <Button key="Cancel" onClick={handleCancle}>{t('Cancel')}</Button>,
            <Button key="Submit" type="primary" onClick={handleSubmit}>{t('Submit')}</Button>
        ]}
    >
        <Form
            labelAlign="right"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 17 }}
            form={form}
        >
            <Form.Item 
                name="OldPassword"
                label={t('Old Password')}
                rules={[{ required: true, message: t('Please input your old password!') }]}
            >
                <Input placeholder={t('Enter Old Password')}/>
            </Form.Item>
            <Form.Item 
                name="NewPassword"
                label={t('New Password')}
                rules={[
                    { required: true, message: t('Please input your new password!') },
                    { min: 6, message: t('Password must be at least 6 characters!') }
                ]}
            >
                <Input placeholder={t('Enter New Password')}/>
            </Form.Item>
        </Form>
    </Modal>);
}

export default PasswordChanger;